
import React from 'react';
import { FormField } from '@/components/ui/form';
import IconInput from '@/components/auth/IconInput';
import { Lock } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';
import { SaasSignupFormValues } from '@/schemas/saasSignupSchema';

interface PasswordFieldsProps {
  form: UseFormReturn<SaasSignupFormValues & { captcha: string }>;
}

const PasswordFields = ({ form }: PasswordFieldsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <FormField
        control={form.control}
        name="password"
        render={({ field }) => (
          <IconInput
            name="password"
            label="Password"
            placeholder="Create a password"
            type="password"
            icon={Lock}
            field={field}
          />
        )}
      />
      
      <FormField
        control={form.control}
        name="confirmPassword"
        render={({ field }) => (
          <IconInput
            name="confirmPassword"
            label="Confirm Password"
            placeholder="Confirm your password"
            type="password"
            icon={Lock}
            field={field}
          />
        )}
      />
    </div>
  );
};

export default PasswordFields;
